// Preloader
export default function Preloader() {
  return null;
}
